import { Alert, Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

interface VoucherAwaitingProps {
  /** Qaysi chaqiruv yetishmayapti — KO'RINADIGAN joyda, izohda emas */
  endpoint: string
  /** Bu blok nima ko'rsatishi kerak edi */
  note: string
}

/**
 * «Bu joyda ma'lumot BO'LISHI KERAK, lekin server hali bermayapti».
 *
 * <h2>⛔ NEGA BO'SH JADVAL EMAS</h2>
 * Bo'shlikni «ma'lumot yo'q» deb chizish eng oson yo'l va eng qimmat
 * xato: sherik uni HAQIQIY javob deb o'qiydi — «menda karta qolmabdi»,
 * «bu oyda hech kim ishlatmabdi». Panelning yolg'oni bu yerda
 * tekshirilmaydi ham, chunki bo'sh jadval ishonarli ko'rinadi. Aynan shu
 * nuqson sinfi bu kod bazasida takrorlanib turadi, shuning uchun
 * bo'shlik OCHIQ aytiladi.
 *
 * ⚠️ `type="error"` EMAS: nosozlik yo'q — panel to'g'ri ishlayapti,
 * server qismi hali yozilmagan. Qizil banner sherikni administratorga
 * qo'ng'iroq qilishga undardi.
 *
 * <h2>⚠️ NEGA `features/profile/AwaitingEndpoint` IMPORT QILINMADI</h2>
 * `features/*` bir-birini import qilmaydi (`07-FRONTEND.md` §6) va buni
 * `tests/guards.mjs` §7 vaucher moduli uchun ALOHIDA qo'riqlaydi.
 * Ikkalasini `shared/ui` ga chiqarish ham yo'l edi, lekin u paytda
 * `features/profile` ning «endpoint yo'q» qarori (u yerda faqat 404,
 * bu yerda 403 ham — `voucherStockApi.isEndpointMissing`) ikkala
 * modulga bir vaqtda bog'lanib qolardi. Takror ONGLI, `LOGIN_PATTERN`
 * bilan ayni sabab.
 */
export function VoucherAwaiting({ endpoint, note }: VoucherAwaitingProps) {
  const { t } = useTranslation()

  return (
    <Alert
      type="info"
      showIcon
      message={t('placeholder.title')}
      description={
        <Flex vertical gap={6} align="flex-start">
          <span>{note}</span>
          <Typography.Text code>{endpoint}</Typography.Text>
        </Flex>
      }
    />
  )
}
